var map = {
	"./1.jpg": 6740,
	"./10.png": 686,
	"./11.png": 7864,
	"./12.png": 8131,
	"./2.jpg": 5475,
	"./3.jpg": 3114,
	"./4.jpg": 6208,
	"./5.jpg": 894,
	"./6.jpg": 3088,
	"./7.jpg": 8902,
	"./8.jpg": 2747,
	"./9.png": 6759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4571;